import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=0968f7de"
var script = {}
import style0 from "./Settings.vue?vue&type=style&index=0&id=0968f7de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports